import { Crew, DogTagComponent, Doll, Ensign, Nation, Permoflages, ShipDestruction, Vehicle, VehicleType } from '~/vortex';

export const PROFILE_PAGE = 'common';
export const VEHICLE_CATEGORY = 'vehicles';
export const CREWS_CATEGORY = 'crews';
export const ENSIGNS_CATEGORY = 'ensigns';
export const PERMOFLAGES_CATEGORY = 'permoflages';
export const DOLLS_CATEGORY = 'dogTagComponents';
export const SHIPDESTRUCTION_CATEGORY = 'shipdestruction';

export const INVENTORY_VEHICLES_KEY = 'vehicles';
export const INVENTORY_CREW_KEY = 'crew';
export const INVENTORY_DOGTAG_KEY = 'dogTag';
export const INVENTORY_HOLD_KEY = 'hold';
export const INVENTORY_STORAGE_KEY = 'storage';
export const INVENTORY_SHIPDESTRUCTION_KEY = 'shipdestruction';

export type ICategories = typeof VEHICLE_CATEGORY | typeof CREWS_CATEGORY | typeof PERMOFLAGES_CATEGORY | typeof ENSIGNS_CATEGORY | typeof DOLLS_CATEGORY | typeof SHIPDESTRUCTION_CATEGORY;
export type IInventoryList =
    | typeof INVENTORY_VEHICLES_KEY
    | typeof INVENTORY_STORAGE_KEY
    | typeof INVENTORY_HOLD_KEY
    | typeof INVENTORY_DOGTAG_KEY
    | typeof INVENTORY_CREW_KEY
    | typeof INVENTORY_SHIPDESTRUCTION_KEY;

export interface IShipdestructionItem {
    id?: string;
    title?: string;
    rarity?: string;
    shipDestructionEffect?: ShipDestruction;
}

export interface IResponse {
    defaultDogTagComponents: DefaultDogTagComponentsData;
    vehicleTypes?: VehicleType[];
    vehicles?: Vehicle[];
    crews?: Crew[];
    permoflages?: Permoflages[];
    ensigns?: Ensign[];
    dogTagComponents?: Doll[];
    nations?: Nation[];
    shipdestruction?: IShipdestructionItem[];
}

export interface IResponseData {
    data: IResponse;
}

export interface DefaultDogTagComponentsData {
    textureData?: DogTagComponent['textureData'];
    borderColor?: string;
    backgroundColor?: string;
}

export interface IActiveDogTag {
    isColorizable?: boolean;
    background?: {
        id?: string;
        icons?: {
            medium?: string;
        };
    };
    symbol?: {
        id?: string;
        icons?: {
            medium?: string;
        };
    };
    backgroundColor?: string;
    borderColor?: string;
    texture?: {
        backgroundIcons?: {
            medium?: string;
        };
        borderIcons?: {
            medium?: string;
        };
    };
}

export type ObjectWithId = {
    id: string;
};

export interface IInventory {
    vehicles?: string[];
    storage?: ObjectWithId[];
    hold?: {
        id: string;
        vehicles: {
            vehicleId: string;
            count: number;
        }[];
    }[];
    dogTag?: string[];
    crew?: ObjectWithId[];
    activeDogTag?: IActiveDogTag;
}

export interface IInventoryState {
    vehicles?: string[];
    storage?: string[];
    hold?: string[];
    dogTag?: string[];
    crew?: string[];
    activeDogTag?: IActiveDogTag;
    shipdestruction?: string[];
}

export type VortexItem = Vehicle | Crew | Permoflages | Ensign | Doll | IShipdestructionItem;

export interface IItemFilters {
    display?: string[];
    nation?: string[];
    type_ship?: string[];
    level_ship?: string[];
    doll_category?: string[];
    crew_category?: string[];
    crew_type?: string[];
    ensign_category?: string[];
    rarity?: string[];
}

export interface _Item {
    isUniqueItem: boolean;
    tags: string[];
    filters?: IItemFilters;
}

export type Item = _Item & VortexItem;

export interface IInventoryData {
    inventory: IInventory;
}

export type DIALOG_ITEM_INFO_TYPE = 'DIALOG_ITEM_INFO';

export type DIALOG_NAMES = DIALOG_ITEM_INFO_TYPE;

export interface IDialogData {
    popupName: DIALOG_NAMES;
    popupData: {
        category: ICategories;
        itemId: string;
    };
}

export interface ICategoriesSettings {
    armoryUrl: string;
    premiumShopUrl: string;
    legendary: string[];
    hidden: string[];
    hiddenIfMissing: string[];
    includeNativeForced: string[];
    isCategoryTitleBlockShown: boolean;
}
